<template>
  <div class="g_page">
    <div class="navBarHeight" :style="{height:nHeight+'px'}">
      <div id="navBar">
        <div class="banner" :class="bannerHideFlag?'hide':''">
          <img src="../../images/z9_bg.jpg" class="b_bg" />
          <!--span class="icon-close" @click="bannerHide"></span-->
        </div>
        <div class="tab">
          <div class="tab_cell" :class="tabIndex==1?'selected':''" @click="getDataIndex(1)">全部</div>
          <div class="tab_cell" :class="tabIndex==2?'selected':''" @click="getDataIndex(2)">最新</div>
          <div class="tab_cell" :class="tabIndex==3?'selected':''" @click="getDataIndex(3)">最优惠</div>
          <div class="tab_cell" :class="tabIndex==4?'selected':''" @click="getDataIndex(4)">销量</div>
        </div>
      </div>
    </div>
    <div class="coupon_goods_list_wrapper">
      <ul class="coupon_goods_list_ul" >
        <router-link :to="{ name: 'item', params: { id: dataList.num_iid },query:{tkUrl:dataList.tkUrl,coupon:dataList.couponPrice}}" v-for="(dataList,index) in dataLists" :key="dataList.id" class="coupon_goods_list_li">
          <div class="li_top">
            <img :src="dataList.pict_url" class="goods_pic"/>
            <p v-if="index==0" class="left_coupon">还剩{{dataList.coupon_remain_count
}} 张券</p>
          </div>
          <div class="li_btm">
            <p class="goods_title">{{dataList.title.slice(0,36)}}</p>
            <p class="goods_shop">
              <img src="../../images/tmallSelected.png" v-if="dataList.mallType=='1'" class='n_goods_shop_img' />
              <img src="../../images/taobao.png" v-if="dataList.mallType=='0'" class='n_goods_shop_img' />
              <!--img src="../../images/haitao.png" v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
              <img src="../../images/juhuasuan.png" v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
              <img src="../../images/taoqianggou.png" v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
              <img src="../../images/video.png" v-if="dataList.isVideo==1" class='n_goods_shop_img' /-->{{dataList.shop_title}}</p>
            <div class="goods_coupon">
              <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.couponPrice
  }}</span>
            </div>
            <div class="goods_money">
              <span class="goods_money_l"><span class="s1">券后</span><span class="s2">￥{{dataList.finalPrice}}</span></span>
              <span class="goods_money_r">原价￥{{dataList.zk_final_price}}</span>
            </div>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
import $ from 'jquery'
import { Indicator } from 'mint-ui' //提示搜索优惠券
  export default{
    name:"twenty",
    data(){
      return {
        bannerHideFlag:false,
        tabIndex:1,
        url:'',
        dataLists:[],
        page:1,
        pageSize:10,
        loading:false,
        sort:"",
        REQUIRE:false,
        navBarFixed:false,
        offsetTop:0,
        nHeight:0,
        catalog:""
      }
    },
    methods:{
      bannerHide:function(){
        this.bannerHideFlag = !this.bannerHideFlag
        this.$nextTick(()=>{
          this.offsetTop = document.querySelector('#navBar').offsetTop
          this.nHeight = $('#navBar').height()
        })
      },
      getDataIndex:function(type){
        this.loading=false
        this.REQUIRE = false
        switch (type) {
          case 2:
            this.tabIndex=2
            this.sort = 'tk_rate_des'//this.order ='addTime'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          case 3:
            this.tabIndex=3
            this.sort = 'total_sales_des'//this.order ='money/price'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          case 4:
            this.tabIndex=4
            this.sort = 'price_des'//this.order ='money/price'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          default:
            this.tabIndex = 1
            this.sort = ''
            this.login()

        }
      },
     /*axios调用数据*/
      login () {
        this.url = "api/searchAPI.php?page_no=" + this.page + "&page_size=" + this.pageSize + "&cat=16,50006843,50002766&end_price=10&has_coupon=true&adzone_id=106344537&is_overseas=false&is_tmall=false&sort="+this.sort
            //console.log(this.url )
            this.$ajax.autoService
                .login(this.url)
                .then((res) => {
                  this.dataLists = this.dataLists.concat(res.data.result_list.map_data.map(function(item){
                    item.couponPrice = item.coupon_info.match(/[\d\.]+/g)[1]
                    item.finalPrice = (item.zk_final_price-item.couponPrice).toFixed(2)
                    if(item.coupon_id){
                      item.tkUrl = item.coupon_share_url
                    }
                    else{
                      item.tkUrl = item.url
                    }
                   var temp = item.pict_url
                   temp = temp.replace('https:', '')
                   temp = temp.replace('http:', '')
                   item.pict_url = "https:" + temp
                    return item
                  }))
                  //this.loading = false
                  this.$nextTick(() => {
                    this.REQUIRE = true;
                    this.loading = false;
                    Indicator.close()
                  });
                  //console.log(this.dataLists)
                }, (res) => {
                    console.log("error")
                    this.REQUIRE = true;
                })
           },
           /*axios向下加载*/
           scrollBottom() {

               this.offsetTop = document.querySelector('#navBar').offsetTop
            // 滚动到页面底部时，请求前一天的文章内容
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

             if (scrollTop > this.offsetTop) {
                this.navBarFixed = true
              } else {
                this.navBarFixed = false
              }

            if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE) {
              // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
              this.REQUIRE = false;
              this.loading = true;
              this.tips = '努力加载中...';
              this.page+=1
              this.login(this.url)
              Indicator.open('正在加载优惠券');

        }
      }
    },
    created (){
     this.login(this.url)


    },
    mounted(){
      this.offsetTop = document.querySelector('#navBar').offsetTop
       window.onscroll = this.scrollBottom
       this.nHeight = $('#navBar').height()
    },
    beforeDestroy(){
      Indicator.close()
      window.onscroll = ""
    },
    computed:{

    }
  }
</script>
<style lang="stylus">
.g_page
  #navBar
    width:100%
    position:fixed
    left:0px
    top:0px
    z-index:999
    .banner
      width:100%
      height:120px
      position:relative
      &.hide
        display:none
      .b_bg
        width:100%
        height:120px
        display:block
      .icon-close
        width:40px
        height:40px
        border-radius:20px
        background:rgba(0,0,0,0.3)
        color:#fff
        font-size:20px
        position:absolute
        right:10px
        top:10px
        line-height:40px
        text-align:center
        font-weight:bold
    .tab
      padding:0 35px
      box-sizing:border-box
      height:80px
      display:flex
      align-items:center
      background:#fff
      .tab_cell
        flex:1
        text-align:center
        font-size:28px
        color:#353535
        &.selected
          color:#000
  .coupon_goods_list_wrapper
    width:750px
    overflow:hidden
    .coupon_goods_list_ul
      width:760px
      .coupon_goods_list_li
        width:370px
        float:left;
        margin:10px 10px 0 0
        padding:0 0 20px 0
        background:#fff
        border:1px solid #e6e6e6
        box-sizing:border-box
        .li_top
          width:100%
          height:368px
          position:relative
          .goods_pic
            width:100%
            height:368px
          .left_coupon
            width:100%
            position:absolute
            left:0px
            bottom:0px
            height:40px
            background:rgba(255,101,0,0.6)
            color:#fff
            font-size:24px
            text-align:center
            line-height:40px
        .li_btm
          padding:10px 15px
          .goods_title
            font-size:28px
            color:#333
            line-height:32px
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height:60px
          .goods_shop
            font-size:20px
            color:#999
            margin-top:10px
            overflow:hidden
            text-overflow:ellipsis
            white-space:nowrap
            .n_goods_shop_img
              width:20px
              height:20px
              display:inline-block
              vertical-align:middle
              margin-left:10px
          .goods_coupon
            height:36px
            color:#fff
            line-height:36px
            font-size:0px
            margin-top:15px
            .goods_coupon_l
              padding:0 8px
              background:#ff6500
              display:inline-block
              vertical-align:top
              font-size:22px
              height:36px
            .goods_coupon_c
              width:13px
              height:36px
              vertical-align:top
            .goods_coupon_r
              background:#ff5400
              display:inline-block
              vertical-align:top
              padding:0 10px
              height:36px
              font-size:22px
          .goods_money
            display:flex
            margin-top:15px
            justify-content:space-between
            line-height:30px
            .goods_money_l
              color:#f40
              .s1
                font-size:22px
                margin-right:5px
              .s2
                font-size:30px
            .goods_money_r
              font-size:22px
              color:#999
              text-decoration: line-through

</style>



// WEBPACK FOOTER //
// src/components/goodsNav/nine.vue